import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import FormElement from "../components/FormBuilder/FormElement";
import { Grid, Paper, Box } from "@mui/material";
import { FormProvider } from "../FormContext";
import SignatureFileFillElement from "../components/FormFillDownloadElements/SignatureFileFillElement";
import RadioSelectionFillElement from "../components/FormFillDownloadElements/RadioSelectionFillElement";
import CheckboxFillElement from "../components/FormFillDownloadElements/CheckboxFillElement";
import HorizontalContainerFillElement from "../components/FormFillDownloadElements/HorizontalContainerFillElement";
import { fetchFormFillData } from "../api/contractVersionService";

const FormFillDownloadPage = () => {
  const { fileId } = useParams();
  const [elements, setElements] = useState([]);
  const ToCaptureRef = React.useRef();
  async function fetchData() {
    const formData = await fetchFormFillData(fileId);
    if (!formData) return;
    setElements(formData);
  }
  const insertInlineCSS = () => {
    console.log("CSS insert invoked");
    const trackChangesClass = document.querySelectorAll(
      ".track-changes.added,.track-changes.deleted,.track-changes.modified"
    );
    if (trackChangesClass.length > 0) {
      console.log(trackChangesClass, "trackChangesClassAdded");
      trackChangesClass.forEach((element) => {
        element.style.backgroundColor = "white";
        element.style.textDecoration = "none";
      });
    }
    const commentClass = document.querySelectorAll(".selection-highlight");
    if (commentClass.length > 0) {
      commentClass.forEach((element) => {
        element.style.backgroundColor = "white";
        element.style.cursor = "none";
      });
    }
  };
  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        if (elements.length > 0) {
          insertInlineCSS();
        }
      }, 1000); // 1 second delay
    };

    // Listen for the window load event to ensure the page is fully rendered
    if (document.readyState === "complete") {
      handleLoad(); // Page is already loaded
    } else {
      window.addEventListener("load", handleLoad); // Wait for the load event
    }

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, [elements]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <FormProvider>
      <Box
        position="relative"
        minHeight="100vh"
        sx={{
          backgroundColor: "#CCCCCC",
        }}
      >
        <Grid container justifyContent="center" ref={ToCaptureRef}>
          <Grid item xs={12} md={8}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Paper elevation={3} sx={{ padding: 2, minHeight: "700px" }}>
                    <Grid container spacing={2}>
                      {elements.map((element, index) => (
                        <Grid
                          xs={12}
                          item
                          key={element.id}
                          sx={{
                            ...(element.type === "signature" ||
                              element.type === "fileUpload"
                              ? { pageBreakInside: "avoid" }
                              : {}),
                            ...(element.type === "logo" && {
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }),
                          }}
                        >
                          {element.type === "fileUpload" ? (
                            <SignatureFileFillElement element={element} />
                          ) : element.type === "radioSelection" ? (
                            <RadioSelectionFillElement element={element} />
                          ) : element.type === "checkBox" ? (
                            <CheckboxFillElement element={element} />
                          ) : element.type === "horizontalContainer" ? (
                            <HorizontalContainerFillElement element={element} />
                          ) : (
                            <FormElement
                              element={element}
                              dragHandle={false}
                              formPreview={true}
                            />
                          )}
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </FormProvider>
  );
};

export default FormFillDownloadPage;
